import { useMutateUpdateContextContent } from '@/hooks/mutation/useMutateUpdateContextContent';
import { useQueryLiveTranscriptBySessionId } from '@/hooks/query/useQueryLiveTranscriptBySessionId';
import { useAuthToken } from '@/hooks/useAuthToken';
import { isProductFeedbackAvailable } from '@/utils/heidiReach';
import { reactQueryClient } from '@/utils/reactQueryClient';
import {
  configureFdeUiHost,
  configureFdeSettingsUiHost as setFdeSettingsUiHost,
} from '@heidi/fde';
import { configureFdeData } from '@heidi/fde/data';
import { useQueryUser } from '@heidi/workspace/data';

configureFdeData({ useAuthToken, queryClient: reactQueryClient, useQueryUser });

configureFdeUiHost({
  useQueryLiveTranscriptBySessionId,
  useMutateUpdateContextContent,
  isProductFeedbackAvailable,
});

export const configureFdeSettingsUiHost = async (): Promise<void> => {
  const [{ SettingsPageHeader }, { useCombinedOrganizationInfo }] = await Promise.all([
    import('@/app-shell/settings/components/page-header'),
    // migration-allow(family-importers): relocated pair — NudgeSettings.tsx read this hook at base and now receives isGlobalAdmin as a settings-host input
    import('@/hooks/query/useCombinedOrganizationInfo'),
  ]);

  const useIsGlobalAdmin = () => useCombinedOrganizationInfo().isGlobalAdmin;

  setFdeSettingsUiHost({
    SettingsPageHeader,
    isGlobalAdmin: useIsGlobalAdmin,
  });
};
